<template>
  <div id="about">
    <v-container>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10">
          <v-card style="border-radius: 9px;">
            <v-img
              lazy-src="@/assets/img/blur.jpg"
              :src="require('@/assets/img/landing-page/pages/news_page.png')"
              width="100%"
              height="232px"
              gradient="to top right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)"
              cover
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row class="my-0 py-0">
        <v-spacer></v-spacer>
        <v-col cols="10">
          <v-btn
            depressed
            rounded
            small
            color="primary300"
            class="white--text font-weight-bold"
            :to="{ name: 'PublicNewsAndEvents' }"
          >
            <v-icon color="black" small class="mr-2">
              mdi-arrow-left
            </v-icon>
            Back
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10">
          <h2>
            Explore our News
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Filters -->
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10" class="d-flex flex-wrap">
          <v-col cols="auto" class="d-inline-flex">
            <SearchText
              :text="'Search'"
              :value="'text'"
              @searchTextChanged="searchTextChanged"
              @keypress.enter.native.prevent="triggerSearch"
              @triggerSearch="triggerSearch"
              @triggerClear="triggerClear"
            ></SearchText>
          </v-col>
          <v-col cols="auto" class="d-inline-flex flex-wrap">
            <v-autocomplete
              v-model="filter.domains"
              class="mx-1"
              :items="domains"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Domain'"
            >
            </v-autocomplete>
            <v-autocomplete
              v-model="filter.subDomains"
              class="mx-1"
              :items="subDomains"
              :item-value="'id'"
              :item-text="'subDomain'"
              outlined
              multiple
              :placeholder="'Subdomain'"
              clearable
            ></v-autocomplete>
            <v-menu
              v-model="fillingDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="fillingDateRangeText"
                  append-icon="mdi-calendar"
                  placeholder="Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="mx-1"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.fillingDate"
                range
                @change="validateDateRange"
                color="primary300"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
            <v-btn
              @click="applyFilters"
              class="ma-2 white--text font-weight-bold"
              rounded
              color="primary300"
            >
              Apply
            </v-btn>
            <v-btn
              @click="resetFilters"
              class="ma-2 white--text font-weight-bold"
              rounded
              color="primary300"
            >
              Reset
            </v-btn>
          </v-col>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- News -->
      <v-row class="mb-10 justify-start" v-if="newsList.length === 0">
        <v-spacer></v-spacer>
        <v-col cols="10" class="d-flex flex-wrap">
          <div>
            <p>
              There are not any News at the moment.
            </p>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row class="mb-10 justify-start">
        <v-spacer></v-spacer>
        <v-col cols="10" class="d-flex flex-wrap">
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="(news, index) in newsList"
            :key="'news-' + index"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="d-flex flex-column"
                elevation="3"
                style="border-radius: 24px; height: 100%;"
                :class="{ 'on-hover': hover }"
                @click="handleCardClick(news.id, $event)"
              >
                <div style="position: relative; width: 100%; text-align: center; overflow: hidden;">
                  <div
                    style="display: flex; justify-content: center; width: 100%; overflow: hidden;"
                  >
                    <v-img v-if="news.thumbnail" height="250" :src="getThumbnailUrl(news)">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular
                            indeterminate
                            color="primary300 "
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      height="250"
                      :src="require('@/assets/img/landing-page/pages/news.png')"
                      gradient="to top right, rgba(61, 1, 154, 0.4), rgba(61, 1, 154, 0.4)"
                    ></v-img>
                    <!-- <v-chip
                      style="position: absolute; top: 15px; left: 15px;"
                      color="secondary300"
                      dark
                    >
                      News
                    </v-chip> -->
                  </div>
                </div>

                <div class="black d-flex flex-column flex-grow-1">
                  <v-card-title class="white--text">
                    <v-row>
                      <v-col>
                        <div>
                          {{ news.title }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="flex-grow-1">
                    <v-row>
                      <v-col class="white--text">
                        <div v-html="truncateDescription(news.description)"></div>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-spacer></v-spacer>
                  <v-card-text>
                    <div
                      v-if="news.tags.length > 0"
                      style="min-height: 40px;"
                      class="d-flex align-center flex-wrap"
                    >
                      <v-chip
                        :color="color(index)"
                        v-for="(tag, index) in news.tags"
                        :key="index"
                        class="ma-2"
                      >
                        {{ tag }}
                      </v-chip>
                    </div>
                  </v-card-text>

                  <v-divider class="mx-4 white"></v-divider>

                  <v-card-actions>
                    <v-row align="center">
                      <v-col class="d-flex align-center">
                        <v-btn icon style="min-width: auto;">
                          <v-icon style="color: white !important;" class="mr-2">
                            mdi-arrow-top-right
                          </v-icon>
                        </v-btn>
                        <p class="mb-0 white--text">Read more</p>
                      </v-col>
                      <v-col class="d-flex justify-end">
                        <v-icon style="color: white !important;">mdi-circle-small</v-icon>
                        <p class="white--text mb-0">
                          {{ formatDateLocaleAE(news.date) }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="pagesLength > 1">
        <v-spacer></v-spacer>
        <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
          <div>{{ totalItems }} Results</div>
        </v-col>
        <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
          <div class="pr-2">Show:</div>
          <div style="max-width: 90px">
            <v-select
              v-model="options.itemsPerPage"
              :items="[10, 20, 30, 40, 50, 100]"
              dense
              outlined
              hide-details
              @change="onItemsPerPageChange"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
          <v-pagination
            v-model="options.page"
            :length="pagesLength"
            :total-visible="7"
            @input="onPageChange"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SearchText from '@/components/shared/search/SearchText';
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'PublicNews',
  components: { SearchText },
  mixins: [util],
  data: () => ({
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    newsList: [],
    totalItems: 0,
    pagesLength: null,
    loading: false,
    news: {
      name: '',
    },
    filter: {
      domains: [],
      subDomains: [],
      fillingDate: [],
    },
    domains: [],
    subDomains: [],
    fillingDateMenu: false,
    search: {},
  }),
  mounted() {
    this.axios.get('/api/v1/scientific-domains').then(res => {
      this.domains = res.data.content;
    });
    this.axios.get('/api/v1/scientific-subdomains').then(res => {
      this.subDomains = res.data.content;
    });
    this.getDataFromApi();
  },
  computed: {
    fillingDateRangeText() {
      return this.filter.fillingDate.join(' ~ ');
    },
  },
  methods: {
    resetFilters() {
      this.filter.domains = [];
      this.filter.subDomains = [];
      this.filter.fillingDate = [];
      this.getDataFromApi();
    },
    searchTextChanged(obj) {
      console.log('[Table] searchTextChanged');

      this.search[obj.value] = obj.search ? obj.search.trim() : '';

      console.log(this.search);
    },
    triggerSearch() {
      console.log('[Table] Search watch');
      this.options.page = 1;
      this.getDataFromApi();
    },
    triggerClear() {
      console.log('[Table] Clear watch');
      this.search = {};
      this.options.page = 1;
      this.getDataFromApi();
    },
    applyFilters() {
      this.getDataFromApi();
    },
    getDataFromApi() {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);

      const baseUrl = '/api/v1/news-and-events/published/news';
      const params = this.getParams();

      const text = this.search.text ? this.search.text.replace(/\s+/g, '+') : '';
      const textParam = text ? `&text=${text}` : '';

      const domainParam =
        this.filter.domains && this.filter.domains.length > 0
          ? `&domains=${this.filter.domains.map(domain => domain.replace(/\s+/g, '+')).join('+')}`
          : '';

      const subDomainParam =
        this.filter.subDomains && this.filter.subDomains.length > 0
          ? `&subDomains=${this.filter.subDomains.map(subDomain => subDomain).join(',')}`
          : '';

      let dateParam = '';
      if (this.filter.fillingDate && this.filter.fillingDate.length > 0) {
        if (this.filter.fillingDate.length === 2) {
          const dateFrom = this.filter.fillingDate[0];
          const dateTo = this.filter.fillingDate[1];
          dateParam = `&dateFrom=${dateFrom}&dateTo=${dateTo}`;
        } else if (this.filter.fillingDate.length === 1) {
          const singleDate = this.filter.fillingDate[0];
          dateParam = `&date=${singleDate}`;
        }
      }

      const url = `${baseUrl}?index=${params.index}&size=${params.size}${textParam}${domainParam}${subDomainParam}${dateParam}`;

      this.axios
        .get(url)
        .then(res => {
          if (res.status === 200) {
            console.log('Get News', res.data);
            this.newsList = res.data.content;
            this.totalItems = res.data.total;
            this.pagesLength = res.data.pagesLength;
          }
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getDataFromApi();
    },
    onPageChange(newPage) {
      this.options.page = newPage;
      this.getDataFromApi();
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      return {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
        text: this.search.text ? this.search.text.replace(/\s+/g, '+') : '',
      };
    },
    handleCardClick(newsId, event) {
      if (event.target.closest('a, button, .v-btn, .v-icon')) {
        return;
      }
      this.$router.push({
        name: 'OverviewNews',
        params: { id: newsId },
      });
    },
    truncateDescription(description) {
      if (!description) return 'No description available.';

      const words = description.split(' ');

      if (words.length > 15) {
        return words.slice(0, 15).join(' ') + '...';
      }

      return description;
    },
    getThumbnailUrl(news) {
      return news && news.thumbnail
        ? `/api/v1/news-and-events/${news.id}/thumbnail/${news.thumbnail}`
        : '';
    },
    validateDateRange() {
      const [startDate, endDate] = this.filter.fillingDate;

      if (startDate && endDate && startDate > endDate) {
        this.filter.fillingDate = [endDate, startDate];
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary300-base) !important;
  border-width: 2px !important;
}
</style>
